module.exports = __webpack_public_path__ + "img/paid-product.8d41e2e.jpg";